import PropTypes from 'prop-types';
import React from 'react';
import { Text } from '../../text/text';

/**
 * Displays a Quote Reference Component to display Quote Reference
 * @param {Object} props The properties
 * @param {Object} props.visualProps A size
 * @param {Object} props.contentProps A prefix label
 * @param {Object} props.stateProps - The stateful product object passed in
 * @returns {QuoteRef} A Quote Reference Component
 */
const QuoteRef = ({ visualProps = {}, contentProps = {}, stateProps }) => {
    // @todo: look to merge this component with ReferenceNumber
    const { prefix } = contentProps;
    const quoteNumber = stateProps.product.getIn(['providerMeta', 'quoteNumber']);

    return quoteNumber ? (
        <Text {...visualProps}>
            {prefix}
            {' '}
            {quoteNumber}
        </Text>
    ) : null;
};

QuoteRef.propTypes = {
    contentProps: PropTypes.shape({
        prefix: PropTypes.string
    }),
    stateProps: PropTypes.shape({
        product: PropTypes.object
    }),
    visualProps: PropTypes.shape({
        size: PropTypes.string
    })
};

export { QuoteRef };
